import * as React from 'react';
import { AxisBottom as VisxAxisBottom } from '@visx/axis';
import { useTheme, useThemeRawValues } from '@leagueplatform/genesis-core';

export type AxisBottomProps = Omit<
  React.ComponentProps<typeof VisxAxisBottom>,
  'hideTicks' | 'labelOffset' | 'stroke' | 'strokeWidth' | 'tickLabelProps'
>;

/**
 * Wraps the visx AxisBottom component and applies genesis styles.
 */
export function AxisBottom(props: AxisBottomProps) {
  const theme = useTheme();
  const rawTheme = useThemeRawValues();

  return (
    <VisxAxisBottom
      tickStroke={theme.colors.onSurfaceBorderSubdued}
      labelOffset={rawTheme.space.oneAndHalf}
      labelProps={{
        fill: theme.colors.onSurfaceTextPrimary,
        fontSize: rawTheme.fontSizes.headingThree,
        textAnchor: 'middle',
        fontWeight: 'bold',
      }}
      stroke={theme.colors.onSurfaceBorderDefault}
      strokeWidth={rawTheme.borderWidths.thick}
      tickLabelProps={() => ({
        fontSize: rawTheme.fontSizes.headingTwo,
        fill: theme.colors.onSurfaceTextSubdued,
        textAnchor: 'middle',
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
